<div class="lum-c-channel-product-mapping-last-pushed-cell">
  <div>
    <span>{{ lastPushQuantity }} &nbsp;</span
    ><span *ngIf="lastPushDatetime" class="muted-text"
      >[{{ lastPushDatetime }}] &nbsp;</span
    ><span *ngIf="remarks">{{ remarks }}</span>
  </div>
</div>
